__turbopack_context__.v({
  "actions": "PatientInsoles-module__iZC2Cq__actions",
  "container": "PatientInsoles-module__iZC2Cq__container",
  "editBtn": "PatientInsoles-module__iZC2Cq__editBtn",
  "empty": "PatientInsoles-module__iZC2Cq__empty",
  "header": "PatientInsoles-module__iZC2Cq__header",
  "hoverBtn": "PatientInsoles-module__iZC2Cq__hoverBtn",
  "list": "PatientInsoles-module__iZC2Cq__list",
  "meta": "PatientInsoles-module__iZC2Cq__meta",
  "name": "PatientInsoles-module__iZC2Cq__name",
  "notes": "PatientInsoles-module__iZC2Cq__notes",
  "row": "PatientInsoles-module__iZC2Cq__row",
  "top": "PatientInsoles-module__iZC2Cq__top",
  "trashBtn": "PatientInsoles-module__iZC2Cq__trashBtn",
});
